import { render, staticRenderFns } from "./CreateCriticalityDialog.vue?vue&type=template&id=0365e160"
import script from "./CreateCriticalityDialog.vue?vue&type=script&lang=js"
export * from "./CreateCriticalityDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports